import {AxiosError} from 'axios'

import {TranslatorScope} from '../../locale/types'

export const MEMBERSHIP_CANCEL_REQUEST_ERROR_CODES = {
  ALREADY_REQUESTED: 'ALREADY_REQUESTED',
  NOT_OPEN: 'NOT_OPEN',
} as const

// Maps a failed cancel-request call to the locale key shown to the member.
// 409 ALREADY_REQUESTED: an open request already exists. 409 NOT_OPEN: the venue has already
// answered (or the request was withdrawn). Anything else is a generic failure.
export const getMembershipCancelRequestErrorKey = (error: unknown): TranslatorScope => {
  const code = (error as AxiosError<{code?: string}> | undefined)?.response?.data.code
  switch (code) {
    case MEMBERSHIP_CANCEL_REQUEST_ERROR_CODES.ALREADY_REQUESTED:
      return 'membershipCancel_errorAlreadyRequested'
    case MEMBERSHIP_CANCEL_REQUEST_ERROR_CODES.NOT_OPEN:
      return 'membershipCancel_errorNotOpen'
    default:
      return 'somethingWentWrong'
  }
}
